import React, { Component } from 'react';
import {
  Col,
  FormLabel,
  FormControl,
  FormGroup,
  Container,
  ListGroup,
  ListGroupItem,
  Row,
  Tab,
  Tabs,
} from 'react-bootstrap';
import { withRouter } from 'react-router-dom';
import Switch from 'react-switch';
import ChangeReason from './ChangeReason/ChangeReason';
import './Dealers.css';
import Api from '../../api/api';
import EditPaymentDetails from './EditPaymentDetails/EditPaymentDetails';
import isANumber from '../../utils/isANumber';
import { userCanUseTPO, userIsAdmin } from '../../utils/RolesBasedUsers';
import InsufficientPermission from './InsufficientPermission';

let initialState = {};

export class DealerEdit extends Component {
  constructor(props) {
    super(props);
    initialState = {
      loading: false,
      authToken: localStorage.getItem('authToken'),
      tabKey: 1,
      tabLabels: {
        editFeatures: 'Edit dealer features',
        editDetails: 'Edit dealer details',
        editTPO: 'Edit Other details',
      },
      dealerName: props.dealer.dealer,
      dealerNo: props.dealer.dealerNo,
      serviceSiteId: props.dealer.serviceSiteId,
      dmsName: props.dealer.dmsName,
      locationName: props.dealer.locationName,
      locationNameOverride: props.dealer.locationNameOverride,
      locationCode: props.dealer.locationCode,
      locationAddress: props.dealer.locationAddress,
      suburb: props.dealer.suburb,
      displaySuburb: props.dealer.displaySuburb,
      newSuburbName: '',
      newLocationName: '',
      featureChangeDetected: false,
      changeReason: '',
      features: props.dealer.features.sort((a, b) => (a.displayName > b.displayName ? 1 : -1)),
      leadTimeInDays: props.dealer.leadTimeInDays,
      dealer: props.dealer,
    };
    this.state = { ...initialState };
  }

  componentDidMount() {
    const { authToken } = this.state;
    if (!authToken) {
      this.props.history.push({
        pathname: '/sessionexpired',
        state: {
          error: 'Unauthorised or Session Expired',
          error_description: 'Please try to login again',
        },
      });
    } else {
      const obj = document.getElementById('navLoginLogout');
      obj.innerText = 'Logout';
    }
  }

  goBackToDealerList = () =>
    this.props.history.push({
      pathname: '/',
      state: { authToken: this.state.authToken },
    });

  saveAndUpdate = async () => {
    this.setState({ loading: true });
    try {
      const payload = {
        featureToggleDtoRequest: [],
        reason: this.state.changeReason,
        leadTimeInDays: +this.state.leadTimeInDays,
        dealerCode: this.state.dealer.dealerCode,
        locationCode: this.state.dealer.locationCode,
        tab: 'features',
      };
      this.state.features.map(feature => {
        payload.featureToggleDtoRequest.push({
          dmsName: this.state.dmsName,
          featureName: feature.feature,
          isEnabled: feature.value,
          serviceSiteId: this.state.serviceSiteId,
        });
      });
      await Api.updateDealer(payload);
      this.goBackToDealerList();
    } catch (error) {
      console.error(error);
      this.props.history.push({
        pathname: '/sessionexpired',
        state: { authToken: this.state.authToken },
      });
    }
  };

  saveAndUpdateSuburbName = async () => {
    this.setState({ loading: true });

    try {
      const payload = {
        locationNameOverride: this.state.newLocationName,
        suburbNameOverride: this.state.newSuburbName,
        serviceLocationId: this.state.serviceSiteId,
      };
      await Api.updateDealerLocationName(payload);
      this.props.history.push({
        pathname: '/',
        state: { authToken: this.state.authToken },
      });
    } catch (error) {
      this.props.history.push({
        pathname: '/sessionexpired',
        state: { authToken: this.state.authToken },
      });
    }
  };

  getValidationStateSuburb = () => {
    const { length } = this.state.newSuburbName.trim();
    const lettersAndSpaces = /^[a-zA-Z0-9!@#$&()-. ]*$/;
    const alpha = this.state.newSuburbName.match(lettersAndSpaces);
    if (length > 0 && alpha) {
      return 'success';
    }
    if (length > 0 && !alpha) {
      return 'error';
    }
    return null;
  };

  getValidationStateLocName = () => {
    const { length } = this.state.newLocationName.trim();
    const lettersAndSpaces = /^[a-zA-Z0-9!@#$&()-. ]*$/;
    const alpha = this.state.newLocationName.match(lettersAndSpaces);
    if (length > 0 && alpha) {
      return 'success';
    }
    if (length > 0 && !alpha) {
      return 'error';
    }
    return null;
  };

  handleLocationNameChange = e => this.setState({ newLocationName: e.target.value });

  handleSuburbNameChange = e => this.setState({ newSuburbName: e.target.value });
  handleLeadTimeChange = e =>
    isANumber(e.target.value) &&
    e.target.value > -1 &&
    this.setState({ leadTimeInDays: e.target.value });

  handleChangeReason = reason => {
    const reasonString = reason.target.value.trimStart();

    this.setState({ changeReason: reasonString });
    if (reasonString.length > 0) {
      this.setState({ featureChangeDetected: true });
    } else {
      this.setState({ featureChangeDetected: false });
    }
  };

  resetForm = () => this.setState(initialState);

  updateOption = (value, event, id) => {
    const { features } = this.state;
    const featureIndex = features.findIndex(feature => feature.feature === id);
    features[featureIndex].value = value;
    this.setState({
      features: [...features],
    });
  };

  render() {
    const disableDealerFeaturesButton = this.state.loading || !this.state.featureChangeDetected;
    const disableDealerDetailsButton =
      this.state.loading ||
      ((this.state.newSuburbName === null || this.state.newSuburbName.trim() === '') &&
        (this.state.newLocationName === null || this.state.newLocationName.trim() === '')) ||
      (!this.state.newSuburbName.match(/^[a-zA-Z0-9!@#$&()-. ]*$/) &&
        !this.state.newLocationName.match(/^[a-zA-Z0-9!@#$&()-. ]*$/));
    return (
      <React.Fragment>
        <Tabs
          activeKey={this.state.key}
          onSelect={this.handleSelect}
          id="toggleLists"
          className="tabsDealer"
        >
          <Tab eventKey={1} title={this.state.tabLabels.editFeatures}>
            {!userIsAdmin() ? (
              <InsufficientPermission />
            ) : (
              <div className="dealerEditWrap">
                <div className="dealerFeaturesWrapper">
                  <Row id="editLeadTime">
                    <Col>
                      <p>Lead Time In Days:</p>
                    </Col>
                    <Col>
                      <FormControl
                        type="number"
                        value={this.state.leadTimeInDays}
                        placeholder="Lead time in days"
                        onChange={this.handleLeadTimeChange}
                        maxLength="50"
                      />
                    </Col>
                  </Row>
                  <ListGroup>
                    {this.state.features.map((feature, index) => (
                      <ListGroupItem
                        key={feature.feature}
                        className={`listGroupItem${index % 2 === 0 ? 1 : 2}`}
                      >
                        <Row>
                          <Col xs={6} className="listGroupItemCol1">
                            {feature.displayName}
                          </Col>
                          <Col xs={6} className="listGroupItemCol2">
                            <Switch
                              onChange={this.updateOption}
                              checked={feature.value}
                              id={feature.feature}
                            />
                          </Col>
                        </Row>
                      </ListGroupItem>
                    ))}
                  </ListGroup>
                  <Row>
                    <form
                      onSubmit={e => {
                        e.preventDefault();
                      }}
                    >
                      <FormGroup
                        controlId="formBasicText"
                        validationState={this.getValidationStateSuburb()}
                      >
                        <FormLabel>Reason for Change *Mandatory</FormLabel>
                        <FormControl
                          type="text"
                          value={this.state.changeReason}
                          placeholder="why the change?"
                          onChange={this.handleChangeReason}
                          maxLength="50"
                        />
                        <FormControl.Feedback />
                      </FormGroup>
                    </form>
                  </Row>

                  <Row id="controls" className="dealerEditLowerRow ">
                    <Container className="dealerEditLowerRow">
                      <div className="dealerFeaturesLowerLine" />
                      <Row className="dealerButtons">
                        <Col xs={6}>
                          <button
                            className={`btn ${!this.state.loading
                              ? 'btn-warning'
                              : 'btn-danger'} dealerButton`}
                            onClick={this.resetForm}
                            disabled={this.state.loading}
                          >
                            Reset Form
                          </button>
                        </Col>
                        <Col xs={6}>
                          <button
                            className={`btn ${disableDealerFeaturesButton
                              ? 'btn-danger'
                              : 'btn-success'} dealerButton`}
                            disabled={disableDealerFeaturesButton}
                            onClick={this.saveAndUpdate}
                          >
                            {!this.state.loading && <p>Save & Update</p>}
                            {this.state.loading && <p>Please wait loading</p>}
                          </button>
                        </Col>
                      </Row>
                    </Container>
                  </Row>
                </div>
                <div className="changeReasonWrapper">
                  <h3>Audit Information</h3>
                  <ChangeReason
                    history={this.props.history}
                    serviceSiteId={this.state.serviceSiteId}
                  />
                </div>
              </div>
            )}
          </Tab>

          <Tab eventKey={2} title={this.state.tabLabels.editDetails}>
            {!userIsAdmin() || !userCanUseTPO() ? (
              <InsufficientPermission />
            ) : (
              <React.Fragment>
                <div className="dealerDetailsWrapper">
                  <div className="dealerAddressWrapperEdit">
                    <span className="dealerAddressName">
                      Dealer name: <strong>{this.state.dealerName.toUpperCase()}</strong>
                    </span>
                    <br />
                    <br />
                    <span className="dealerAddressName">
                      Suburb name : <strong>{this.state.suburb}</strong>
                    </span>
                    <br />
                    <span className="dealerAddressName">
                      Suburb display name : <strong>{this.state.displaySuburb}</strong>
                    </span>
                    <br />
                    <form>
                      <FormGroup
                        controlId="formBasicText2"
                        validationState={this.getValidationStateSuburb()}
                      >
                        <FormLabel>Override suburb display name:</FormLabel>
                        <FormControl
                          type="text"
                          value={this.state.newSuburbName}
                          placeholder="Enter new suburb display name"
                          onChange={this.handleSuburbNameChange}
                        />
                        <FormControl.Feedback />
                      </FormGroup>
                    </form>
                    <br />
                    <span className="dealerAddressName">
                      Location name : <strong>{this.state.locationNameOverride}</strong>
                    </span>
                    <form>
                      <FormGroup
                        controlId="formBasicText3"
                        validationState={this.getValidationStateLocName()}
                      >
                        <FormLabel>Override location name:</FormLabel>
                        <FormControl
                          type="text"
                          value={this.state.newLocationName}
                          placeholder="Enter new location name"
                          onChange={this.handleLocationNameChange}
                        />
                        <FormControl.Feedback />
                      </FormGroup>
                    </form>
                  </div>
                </div>

                <div>
                  <Container className="dealerEditLowerRow">
                    <div className="dealerFeaturesLowerLine" />
                    <Row>
                      <Col xs={6} className="dealerEditCancelCol">
                        <span />
                      </Col>
                      <Col xs={6} className="dealerEditSaveCol">
                        <button
                          className={`btn ${disableDealerDetailsButton
                            ? 'btn-danger'
                            : 'btn-success'} dealerEditSaveButton`}
                          onClick={this.saveAndUpdateSuburbName}
                          disabled={disableDealerDetailsButton}
                        >
                          {!this.state.loading && <p>Save & Update</p>}
                          {this.state.loading && <p>Please wait loading</p>}
                        </button>
                      </Col>
                    </Row>
                  </Container>
                </div>
              </React.Fragment>
            )}
          </Tab>

          <Tab eventKey={3} title={this.state.tabLabels.editTPO}>
            <EditPaymentDetails dealer={this.props.dealer} onSuccess={this.goBackToDealerList} />
          </Tab>
        </Tabs>
      </React.Fragment>
    );
  }
}

export default withRouter(DealerEdit);



// WEBPACK FOOTER //
// ./src/components/Dealers/DealerEdit.js